import React from "react";
import {useTranslation} from "react-i18next";

/**
 Renders an horizontal mouseover drop-down filled with the given enum values.
 The options appears on the right of the active one, with a pipe separator
 Ex.: 2021  2020 | 2019
 */
export const ALL = 'ALL';
export default function FlatMultiSelect(props) {

    const enums = props.enums;
    const curValues = props.curValues;
    const curClass = props.curClass;
    const otherClass = props.otherClass;
    const clickFunction = props.clickFunction;
    const clickParamFromEnum = props.clickParamFromEnum;
    const useAll = props.useAll;
    const divStyle = props.divStyle;
    const doNotTranslate = props.doNotTranslate;

    const {t, i18n} = useTranslation();

    if (!enums || !enums.length) {
        console.log('EnumSelector props error: ' + enums);
        return "";
    }

    const span = <span className={"nowrap"}>
        {useAll &&
            <span key={'span_all'} className={enums.length === curValues.length ? curClass : otherClass}
                  style={{marginRight: '4px'}} onClick={() => clickFunction(ALL)}>
                {'All'}
            </span>
        }
        {enums.map(enumElem => {
            let key = enumElem.key;

            let fieldClass;
            if (curValues.find(curVal => curVal.key === key)) {
                fieldClass = curClass;
            } else {
                // The active element is highlighted
                fieldClass = otherClass;
            }

            let functionCall = clickParamFromEnum ? () => clickFunction(enumElem) : clickFunction;

            // Get the translation, if defined
            const label = !doNotTranslate && i18n.exists(enumElem.key) ? t(enumElem.key) : enumElem.label;

            return <span key={'span' + key} className={fieldClass} style={{marginRight: '4px'}} onClick={functionCall}>
                    {label}
                </span>;
        })}
    </span>;
    return (divStyle ? <div style={divStyle}>
        {span}
    </div> : <>{span}</>);
}
